// extracted by mini-css-extract-plugin
export default {"score":"LastAnswer_score__vGi6P"};